var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrorUnsupported = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 120,
    viewBox: "0 0 158 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.257 117H105.057M120.257 117H155M120.257 117L110.862 77.5385M47.5143 117H84.4286M47.5143 117H23.6286M47.5143 117L51.8989 95.0769M51.8989 95.0769L110.862 77.5385M51.8989 95.0769L56.9412 69.8654M110.862 77.5385L99.6286 32.5962M105.057 55.6154L56.9412 69.8654M56.9412 69.8654L61.9835 44.6538M61.9835 44.6538L70.1535 3.80388C70.247 3.33646 70.6574 3 71.1341 3H92.3105C92.7799 3 93.1862 3.32656 93.2871 3.78504L99.6286 32.5962M61.9835 44.6538L99.6286 32.5962M11.6857 117H3",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrorUnsupported);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error-unsupported.025e4042adef42336b27923e41121099.svg";